module.exports = __webpack_public_path__ + "static/media/giftcard_15.80ba088c.jpg";